import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { Dashboard,ReleaseNotes } from 'src/api/models';
import { DataBusLicense } from 'src/api/models/data-bus-license';

import { DataBusService } from 'src/api/services/data-bus.service';
import { ConfigService, DashboardService, UserService } from 'src/api/services';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { ModalDirective } from 'ngx-bootstrap/modal';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  @ViewChild("newRelease", { static: false }) newRelease: ModalDirective;

  test: boolean = false;
  dashboards: Dashboard[] = null;
  newDashboards: Dashboard[];
  selected: Dashboard;
  releaseNotes: ReleaseNotes;

  constructor(private router: Router, 
    private readonly dataBus: DataBusService,
    private readonly app: ApplicationConfigService,
    public userService: UserService,
    public config: ConfigService,
    public authService: AzureAuthService,
    public configService: ApplicationConfigService,
    private readonly dashboard: DashboardService) { }

  ngOnInit(): void {
    this.app.loadApplications();
    this.dashboard.DashboardGetMyDashboards()
      .subscribe(res => {
        var myDashboards = res;
        if (myDashboards.length > 0){
          myDashboards = myDashboards.filter(d => this.authService.isAdmin() || d.customerId == this.app.customerId);
          if (myDashboards.length > 0){
            var fav = myDashboards[0]
            if (fav){
              this.selected = fav;
            }
          }
        }
        if (this.newRelease && !this.authService.userProfile.acknowledgedReleaseNotes){
          this.config.ConfigGetReleaseNotes().subscribe(r => {
            this.releaseNotes = r;
            this.newRelease.show();
          });          
        }
        if (myDashboards == null){
          this.dashboards = [];
        }else{
          this.dashboards = myDashboards;
        }
      });
      this.dashboard.DashboardGetRecentDashboards()
      .subscribe(res => {
        this.newDashboards = res;
      });
  }

  ackRelease(){
    //todo: implement ack step
    this.userService.UserAcknowledgeReleaseNotes().subscribe(r => {

    });
  }
}
